import React from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Home from "./pages/Home";        // ✅ Import Home
import Contact from "./pages/Contact";  // ✅ Import Contact
import UploadCSV from "./pages/UploadCSV";
import PlpUrlChange from "./pages/PlpUrlChange"; // Import PlpUrlChange from pages folder

import About from "./pages/About";
import Innovid from "./pages/Innovid";

function App() {
  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "1rem" }}>
        <Routes>
          <Route path="/" element={<Home />} />          {/* Home */}
          <Route path="/about" element={<About />} /> {/* Contact */}
          <Route path="/contact" element={<Contact />} /> {/* Contact */}
          <Route path="/UploadCSV" element={<UploadCSV />} /> {/* Upload */}
          
          <Route path="/plp-url-change" element={<PlpUrlChange />} /> {/* PLP URL Change */}
          <Route path="/innovid" element={<Innovid />} /> {/* PLP URL Change */}
         
        </Routes>
      </div>
    </div>
  );
}

export default App;
